const microAnimations = () => {window.onload = function() { 
     
        let mm = gsap.matchMedia();
        mm.add({
            isMobile: "(max-width: 768px)",
            isDesktop: "(min-width: 769px)"
        }, (context) => {
            let { isMobile, isDesktop } = context.conditions;
            const scroll = (trigger, mobileStart) => {
                return gsap.timeline({
                    defaults: {
                        duration: 1.5,
                        ease: "power3.out",
                        opacity: 0,
                    },
                    scrollTrigger: {
                        trigger: trigger,
                        start: isDesktop? "top 60%" : mobileStart,
                        toggleActions: "play none none reverse",
                    },
                });
            }

            const tlShowPage = gsap.timeline({
                defaults: { 
                    duration: 2,
                    ease: "power3.out"
                }
            });

            isDesktop ?
            scroll('.promo__text-wrapper').from(".promo__subtitle > span:first-child", {  x: 50})
                                            .from(".promo__subtitle > span:nth-child(2)", {  x: -50}, "<10%")
                                            .from(".promo__subtitle > span:nth-child(3)", { x: -50}, "<10%")
                                            .from(".promo__subtitle > span:nth-child(4)", {  x: 50}, "<10%")
                                            .from(".promo__text", { x: 50}, "<10%") :
            tlShowPage.from(".promo__word", { x: -50, stagger: 0.1, opacity: 0})
                        .from(".promo__text", { x: -50, opacity: 0}, "<10%");
                
                
            scroll('.albums__desc', 'top 80%').from(".albums__desc > span:first-child", {  x: isDesktop? 50 : -50})
                                            .from(".albums__item-tracklist > .mobile-hidden", {  x: isDesktop ? -50 : 0}, isDesktop? "<10%": "<")
                                            .from(".albums__desc > .mobile-visible", { x: isDesktop ? 0 : 50}, isDesktop? "<": "<10%")
                                            .from(".albums__item-title > span", {  x: isDesktop ? 50 : 0, stagger: 0.1}, "<10%");
                                    
            scroll('.paradigms__title', 'top 60%').from(".paradigms__title > span:first-child", { x: -50})
                                                .from(".paradigms__title > span:nth-child(2)", { x: -50 }, "<10%")
                                                .from(".paradigms__title > span:nth-child(3)", { x: isDesktop ? 50 : -50}, "<10%")
                                                .from(".paradigms__title > span:nth-child(4)", { x: isDesktop ? 50 : -50}, "<10%")
                                                .from(".paradigms__title > span:nth-child(5)", { x: isDesktop ? 50 : -50}, "<10%")
                                                .from(".paradigms__desc", { x: isDesktop ? 50 : -50}, "<10%");
                                        
            scroll('.freedom__title', 'top 30%').from(".freedom__title > span", { x: isDesktop? 50 : -50, stagger: 0.1})
                                        .from(".freedom__desc", { x: -50}, "<10%");
            
            scroll('.unconventional__header', 'top 80%').from(".unconventional__header > span:first-child", { x: -50})
                                                        .from(".unconventional__header > span:nth-child(2)", { x: isDesktop? 0 : 50}, isDesktop ? "<" : "<10%")
                                                        .from(".unconventional__header > span:nth-child(3)", { x: isDesktop? 50 : -50}, "<10%")
                                                        .from(".unconventional__header > span:nth-child(4)", { x: -50}, "<10%")
                                        
            let sections = gsap.utils.toArray('.unconventional__item');
            
            sections.forEach(section => {
                scroll(section, 'top 60%').from(section, { x: 50, stagger: 0.1})
            });
            
            scroll('.unconventional__footer', 'top 80%').from(".unconventional__footer > span", { x: isDesktop? 50 : -50, stagger: 0.1})
            
            scroll('.contact-us__title', 'top 80%').from(".contact-us__title > span", { x: -50, stagger: 0.1})

            scroll('.footer', 'top 80%').from(".footer__item p", { x:isDesktop ? 0 : 50, stagger: 0.1, opacity: isDesktop ? 1 : 0})
                                        .from(".footer__list-item", { x:isDesktop ? 0 : 50, stagger: 0.1,  opacity: isDesktop ? 1 : 0}, "<10%")
        });
    }
    console.log('microanimations')
}

export default microAnimations;
